import type { ArgsOf, RequestOf } from "@p0security/shared/types/access/index";
import { Access } from "@p0security/shared/types/access/index";
import type { EmptyAccessDelegation } from "@p0security/shared/types/lifecycle";

const delegation: EmptyAccessDelegation = {};

export const BundleAccesses = {
  request: Access({
    description: "Request access via a predefined access bundle",
    label: "Bundle access",
    maturity: "preview",
    // Bundle items (and thus their delegates) are only known once the bundle
    // definition is read at request time, so delegation keys can't be static.
    delegation,
    generated: {},
    parameters: {
      bundleId: {
        type: "static",
        label: "Bundle",
        description: "The access bundle being requested",
      },
      label: {
        type: "generated",
        label: "Bundle label",
        optional: true,
      },
      description: {
        type: "generated",
        label: "Bundle description",
        optional: true,
      },
    },
    render: { locator: "label" } as const,
  }),
};

export type BundleAccesses = typeof BundleAccesses;
export type BundleAccess = BundleAccesses[keyof BundleAccesses];
export type BundleRequestAccess = BundleAccesses["request"];
export type BundleRequestAccessArgs = ArgsOf<BundleRequestAccess>;
export type BundleRequestAccessRequest = RequestOf<BundleRequestAccess>;
